import React from "react"
import "./Service.css"
function Service() {
  return (
    <div className="service component__space" id="Services">
      <div className="heading">
        <h1 className="heading">My Services</h1>
        <p className="heading p__color">
          Grave aux partenaires ,beneficiez des services de qualité dans les
          domaines marqueting et communication digital ,Branding ,Digital
          marketing
        </p>
        <p className="heading p__color">
          Transformation numerique des Entreprises
        </p>
      </div>
      <div className="container">
        {/*  ***************  Les services  ************* */}
        {/*  ****ligne 1 ******* */}
        <div className="row">
          {/* *les conteneur de services1*  */}
          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"></path>
                  <line x1="2" y1="20" x2="2" y2="20"></line>
                </svg>
              </div>
              <div className="service__meta">
                <h1 className="servce__text">Business Strategy</h1>
                <p className="p service __text p__color">
                  comment nous vous secourons dans votre business ou vous
                  accompagnons dans la creation de nouveau business ?<br />
                </p>
                <p className="p service __text p__color">
                  Nous assurons le branding et le positionnement de votre
                  marque,entrtenons et promouvons son image à travers les grands
                  marchés.
                </p>
                <hr />
                <p className="p service __text p__color">
                  <h5>Decouvrez la difference !</h5>
                </p>
              </div>
            </div>
          </div>
          {/* fin conteneur  */}

          {/* *les conteneur de services2*  */}
          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                  <polyline points="2 17 12 22 22 17"></polyline>
                  <polyline points="2 12 12 17 22 12"></polyline>
                </svg>
              </div>
              <div className="service__meta">
                <h1 className="servce__text">
                  Digital Marketing &amp; Community Management
                </h1>
                <p className="p service __text p__color">
                  A quoi va me servir un community manager ?<br />
                </p>
                <p className="p service __text p__color">
                  En marketing digital,le community manager est un expert des
                  communautés Web. Son rôle : fédérer un groupe d'internautes
                  autour d'un intérêt commun et animer les échanges sur ce
                  thème, tout en veillant au respect des règles de bonne
                  conduite au sein de la communauté. Il a pour première mission
                  de développer la présence de l'organisation dont il se fait le
                  porte-parole (marque, association, personnalité...), sur les
                  médias sociaux.
                </p>
                <hr />
                <p className="p service __text p__color">
                  <h5>
                    Multipliez votre chiffre d'affaire par 100 en profitant du
                    potentiel du numerique !
                  </h5>
                </p>
              </div>
            </div>
          </div>
          {/* fin conteneur  */}

          {/* *les conteneur de services3*  */}
          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>

              <div className="service__meta">
                <h1 className="servce__text">Software and Web development</h1>
                <p className="p service __text p__color">
                  Nous sommes un mélange d'experts en logiciels, de visionnaires
                  de produits et de magiciens du design, liés par une passion
                  commune pour le développement
                  <br />
                </p>
                <p className="p service __text p__color">
                  Notre équipe de développeurs traitera votre projet comme s'il
                  s'agissait du leur, grâce à la culture de propriété h5
                  encouragée dans notre entreprise.
                </p>
                <hr />
                <p className="p service __text p__color">
                  <h5>
                    Chaque projet est unique et nous nous engageons à trouver
                    les solutions idéales pour atteindre les objectifs de nos
                    partenaires.
                  </h5>
                </p>
              </div>
            </div>
          </div>
          {/* fin conteneur  */}
        </div>

        {/*  ****ligne 2 ******* */}
        <div className="row">
          {/* *les conteneur de services 4*  */}
          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                  <line x1="8" y1="21" x2="16" y2="21"></line>
                  <line x1="12" y1="17" x2="12" y2="21"></line>
                </svg>
              </div>
              <div className="service__meta">
                <h1 className="servce__text">Solutions de bureautique</h1>
                <p className="p service __text p__color">
                  Automatisez vos taches routinier de bureautique pour une plus
                  grande fluidité des servies
                  <br />
                </p>
                <p className="p service __text p__color">
                  Des solution de facturation personaliser ,Outils de gestion de
                  stocks , Correspondances, Comptabilité et Billet d'invitation.
                </p>
                <hr />
                <p className="p service __text p__color">
                  <h5>Vous passez moin de temps sous Office !</h5>
                </p>
              </div>
            </div>
          </div>
          {/* fin conteneur  */}

          {/* *les conteneur de services 5*  */}
          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <div className="service__meta">
                <h1 className="servce__text">
                  Materiels InformatiqueqMaintenace Logiciel et Materielle
                </h1>
                <p className="p service __text p__color">
                  Une offre de maintenance informatique adaptée à vos besoins et
                  à vos contraintes
                  <br />
                </p>
                <p className="p service __text p__color">
                  englobe différentes opérations relatives à la gestion du
                  système d’information d’une entreprise. Ce spécialiste
                  intervient généralement dans l’exploitation et la sécurisation
                  des réseaux, le traitement des incidents, et dans le
                  renouvellement du parc informatique.
                  <br />
                  maintenance préventive &amp; audit et reparations
                </p>
                <hr />
                <p className="p service __text p__color">
                  <h5>
                    Stop aux disfonctionnement de votre systeme informatique !
                  </h5>
                </p>
              </div>
            </div>
          </div>
          {/* fin conteneur  */}

          {/* *les conteneur de services 6*  */}
          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                  <line x1="8" y1="21" x2="16" y2="21"></line>
                  <line x1="12" y1="17" x2="12" y2="21"></line>
                </svg>
              </div>
              <div className="service__meta">
                <h1 className="servce__text">Formation</h1>
                <p className="p service __text p__color">
                  Booster votre carrière ou rendez vous indispensable dans le
                  processus de transformation numerique de vos societés
                </p>
                <p className="p service __text p__color">
                  Après ces formations, vous serez indispensable dans votre
                  entreprise. Développeur web,analyste DATA ou développeur de
                  logiciel, vous incarnez les progrès des nouvelles
                  technologiques.
                </p>
                <hr />
                <p className="p service __text p__color">
                  <h5>
                    Apuyez en même temps vos dossiers de demande de visa grace
                    aux certifications des plus grandes université Americaines
                    reconnues partout dans le monde !
                  </h5>
                </p>
              </div>
            </div>
          </div>
          {/* fin conteneur  */}
        </div>
      </div>
    </div>
  )
}

export default Service
